import get from 'hs-lodash/get';
import { AFTER } from 'automation-ui-canvas/components/canvas/copyPaste/placements';
import { getPasteableData } from 'automation-ui-canvas/components/canvas/copyPaste/copyActionsToLocalStorage';
import { canPasteActionWithAlert } from 'automation-ui-canvas/components/canvas/copyPaste/canPasteAction';
import { getCleanedConnections } from 'automation-ui-canvas/components/canvas/copyPaste/getCleanedConnections';
import { insertAndUpdateFlowWithLocallyStoredAction } from 'automation-ui-canvas/components/canvas/copyPaste/insertAndUpdateFlowWithLocallyStoredAction';
import { trackEvent } from 'automation-ui-canvas/utils/trackingUtils';
import Trackables from 'automation-ui-usage-tracking/Trackables';
const getBranchesAndDefaultBranchNameFromAction = action => {
  let branches;
  let defaultBranchName;
  if (action.isBranch()) {
    const connection = getCleanedConnections(action);
    branches = connection.getBranches();
    defaultBranchName = connection.getDefaultBranchName();
  }
  return {
    branches,
    defaultBranchName
  };
};
export function pasteActionInFlow({
  action,
  dispatch,
  edgeId,
  flow,
  isPreviousActionLeafNode,
  onSaveCallback = () => {},
  placement,
  setPastingData,
  showLoadingOverlay = () => {},
  showPasteActionModal,
  updateFlow
}) {
  const pasteableData = getPasteableData();

  // Dev note: there is a chance that we are trying to paste without anything in LS.
  const actionToPaste = (pasteableData || {}).action;
  trackEvent(Trackables.CLICKED_PASTE_ACTION, {
    actionType: get(actionToPaste, 'actionType'),
    // placement will always be undefined when pasting from action config
    subAction: placement || 'fromActionConfig'
  });
  const onPasteAction = ({
    branchIndexToSetDownstreamActionsIn,
    deleteDownstreamActions,
    parentBranchIndex
  } = {}) => {
    showLoadingOverlay(true);
    const {
      branches,
      defaultBranchName
    } = getBranchesAndDefaultBranchNameFromAction(actionToPaste);
    return insertAndUpdateFlowWithLocallyStoredAction({
      baseActionId: action ? action.getActionId() : undefined,
      branches,
      branchIndexToSetDownstreamActionsIn,
      defaultBranchName,
      deleteDownstreamActions,
      dispatch,
      edgeId,
      flow,
      parentBranchIndex,
      placement,
      updateFlow,
      onSaveCallback
    }).finally(() => {
      showLoadingOverlay(false);
    });
  };
  if (canPasteActionWithAlert({
    flowObjectTypeId: flow.objectTypeId,
    copiedData: pasteableData,
    flow,
    dispatch
  })) {
    if (action && action.isBranch() && placement === AFTER) {
      setPastingData(pasteableData, onPasteAction, action);
      return showPasteActionModal();
    }
    if (actionToPaste.isListBranch(true) || actionToPaste.isStaticBranch()) {
      if (action && action.isLeafNode() && placement === AFTER) {
        return onPasteAction({});
      }
      if (!action && edgeId && isPreviousActionLeafNode) {
        return onPasteAction({});
      }
      setPastingData(pasteableData, onPasteAction);
      return showPasteActionModal();
    }
    return onPasteAction({});
  }
  return null;
}
export function pasteActionInFlowAfterVirtualAction({
  baseActionId,
  flow,
  showLoadingOverlay,
  setPastingData,
  showPasteActionModal,
  updateFlow,
  dispatch
}) {
  const pasteableData = getPasteableData();

  // Dev note: there is a chance that we are trying to paste without anything in LS.
  const actionToPaste = (pasteableData || {}).action;
  trackEvent(Trackables.CLICKED_PASTE_ACTION, {
    actionType: get(actionToPaste, 'actionType'),
    subAction: AFTER
  });
  const onPasteAction = ({
    branchIndexToSetDownstreamActionsIn,
    deleteDownstreamActions
  } = {}) => {
    showLoadingOverlay(true);
    const {
      branches,
      defaultBranchName
    } = getBranchesAndDefaultBranchNameFromAction(actionToPaste);
    return insertAndUpdateFlowWithLocallyStoredAction({
      branches,
      branchIndexToSetDownstreamActionsIn,
      defaultBranchName,
      deleteDownstreamActions,
      baseActionId,
      flow,
      placement: AFTER,
      updateFlow,
      dispatch
    }).finally(() => {
      showLoadingOverlay(false);
    });
  };
  if (canPasteActionWithAlert({
    flowObjectTypeId: flow.objectTypeId,
    copiedData: pasteableData,
    flow,
    dispatch
  })) {
    if (actionToPaste.isBranch() && flow.getActions() && !!flow.getActions().size) {
      setPastingData(pasteableData, onPasteAction);
      return showPasteActionModal();
    }
    return onPasteAction({});
  }
  return null;
}